import { Button, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import HeadingCard from "../../../newComponent/NewCardsComp/HeadingCard";
import MetaDetailedReport from "./MetaDetailedReport";
import MetaUserWiseReport from "./MetaUserReport";
import FilterButtonComponent from "../../../newComponent/NewButtonComp/FilterButtonComponent";
import MissMetaLead from "../../missedAutoAssignLeads/MissMetaLead";
import MissMetaleadDetails from "./MissMetaleadSection/MissMetaleadDetails";
import CustomPopup from "../../../../components/CustomPopup";
import NoEnquiry from "../../../components/DataTransferComp.jsx/NoEnquiry";
import ConfirmationPopup from "../../../../components/ConfirmationPopup";
import CustomSnackbar from "../../../components/ui-component/snackbar/CustomSnackbar";
import { useGetTokenOrLogout } from "../../../../utils/token";
import CampaignWiseReport from "./campaignWiseReport/CampaignWiseReport";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function ShowMetaEnquiryReport() {
  const [selectedCriteria, setSelectedCriteria] = useState("detailedreport");
  const [isDownloadAccess, setIsDownloadAccess] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedid, setSelectedid] = useState([]);
  const [massCancelPopup, setMassCancelPopup] = useState(false);
  const getTokenOrLogout = useGetTokenOrLogout();





useEffect(() => {
 if(selectedCriteria==="userwisereport" || selectedCriteria==="campaignreport") {
  setOpen(true)
 }

}, [selectedCriteria])


  const handleChipClick = (criteria) => {
    setSelectedCriteria(criteria);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleMassCancelOpen = () => {
    setMassCancelPopup(true);
  };

  const handleMassCancelClose = () => {
    setMassCancelPopup(false);
    setSelectedid([]);
  };



  return (
    <>
      <Grid container spacing={2}>
        {/* Heading */}
        <Grid item xs={12} lg={3.5} md={5} sm={6}>
          <HeadingCard label="Meta Enquiry Report" />
        </Grid>

        {/* Added details and user wise report buttons*/}
        <Grid item xs={12} md={12} sm={12} lg={12}>
          <Grid container>
            <Grid item xs={12} md={8} sm={12} lg={8}>
              <Grid container gap={2}>
               
                <Button
                  size="small"
                  style={{
                    fontWeight:
                      selectedCriteria === "detailedreport" ? 600 : 500,
                    background:
                      selectedCriteria === "detailedreport" ? "#07b344" : "",
                    borderRadius: "10px",
                    color:
                      selectedCriteria !== "detailedreport"
                        ? "#364152"
                        : "white",
                    border:
                      selectedCriteria !== "detailedreport"
                        ? "0.5px solid #b2b2b4"
                        : "",
                  }}
                  onClick={() => handleChipClick("detailedreport")}
                >
                  Detailed Report
                </Button>

                <Button
                  size="small"
                  style={{
                    fontWeight:
                      selectedCriteria === "userwisereport" ? 600 : 500,
                    background:
                      selectedCriteria === "userwisereport" ? "#07b344" : "",
                    borderRadius: "10px",
                    color:
                      selectedCriteria !== "userwisereport"
                        ? "#364152"
                        : "white",
                    border:
                      selectedCriteria !== "userwisereport"
                        ? "0.5px solid #b2b2b4"
                        : "",
                  }}
                  onClick={() => handleChipClick("userwisereport")}
                >
                  User Wise Specific Report
                </Button>

                       <Button
                  size="small"
                  style={{
                    fontWeight:
                      selectedCriteria === "campaignreport" ? 600 : 500,
                    background:
                      selectedCriteria === "campaignreport" ? "#07b344" : "",
                    borderRadius: "10px",
                    color:
                      selectedCriteria !== "campaignreport"
                        ? "#364152"
                        : "white",
                    border:
                      selectedCriteria !== "campaignreport"
                        ? "0.5px solid #b2b2b4"
                        : "",
                  }}
                  onClick={() => handleChipClick("campaignreport")}
                >
                  Facebook Campaign Wise Report
                </Button>
              </Grid>
            </Grid>
            {selectedCriteria !== "missleads" && (
              <Grid
                item
                xs={12}
                md={4}
                sm={12}
                lg={4}
                display="flex"
                justifyContent="flex-end"
              >
                <FilterButtonComponent
                  onClick={handleToggle}
                  text="Filter"
                  open={open}
                  showendIcon={true}
                />
              </Grid>
            )}

        
          </Grid>
        </Grid>

        <Grid item xs={12}>
          {/* showing component accoeding to criteria */}
          {selectedCriteria === "detailedreport" && (
            <MetaDetailedReport
              open={open}
              isDownloadAccess={isDownloadAccess}
            />
          )}
          {selectedCriteria === "userwisereport" && (
            <MetaUserWiseReport
              open={open}
              isDownloadAccess={isDownloadAccess}
            />
          )}

 {selectedCriteria === "campaignreport" && (
            <CampaignWiseReport
              open={open}
              isDownloadAccess={isDownloadAccess}
            />
          )}
 
        </Grid>
      </Grid>

   

      
    </>
  );
}
